import { render } from "./boxSearchTv.vue?vue&type=template&id=a0bb268c&scoped=true"
import script from "./boxSearchTv.vue?vue&type=script&lang=js"
export * from "./boxSearchTv.vue?vue&type=script&lang=js"

import "./boxSearchTv.vue?vue&type=style&index=0&id=a0bb268c&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0bb268c"]])

export default __exports__